import { render, staticRenderFns } from "./dzqm.vue?vue&type=template&id=61c6d9e9&scoped=true"
import script from "./dzqm.vue?vue&type=script&lang=js"
export * from "./dzqm.vue?vue&type=script&lang=js"
import style0 from "./dzqm.vue?vue&type=style&index=0&id=61c6d9e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c6d9e9",
  null
  
)

export default component.exports